import type { RightSectionWrapperProps } from './types';

export function RightSectionWrapper({
    rightSection,
    rightRef,
    isRightWrapped,
    variant,
}: RightSectionWrapperProps) {
    if (!rightSection) return null;

    // NOTE: We only do "wrap detection" on lg+ (see effect in MonthlyPremium). For smaller screens, `rightSection`
    // should naturally stack in a column (PlanCard controls that).
    if (variant === 'single') {
        return (
            <div
                className={`w-full lg:flex-1 lg:flex lg:justify-end ${
                    isRightWrapped ? 'lg:basis-full lg:justify-center lg:mt-2' : 'lg:justify-end'
                }`}
            >
                <div ref={rightRef} className="w-full lg:w-auto">
                    {rightSection}
                </div>
            </div>
        );
    }

    return (
        <div
            ref={rightRef}
            className={`w-full text-center lg:w-auto ${
                isRightWrapped ? 'lg:basis-full lg:w-full lg:mt-2 lg:flex lg:justify-center' : 'lg:w-auto'
            }`}
        >
            {rightSection}
        </div>
    );
}

